import { Model, Attr, HasOne } from 'spraypaint';
import { NullProxy, RecordProxy } from 'spraypaint/lib-esm/proxies';
import ApplicationRecord from 'spa-ionata-admin/lib/models/ApplicationRecord';
import LocaleItem from '../services/LocaleItem';
import User from './User';

export type SectorProxy = RecordProxy<Sector> | NullProxy<Sector>;

@Model()
export default class Sector extends ApplicationRecord {
  static jsonapiType = 'sectors';

  // --- Attributes
  // --------------

  // required
  @Attr() name!: TranslatableText;

  // required
  // maxLength: 50
  // pattern: ^[-a-zA-Z0-9_]+$
  @Attr() slug!: string;

  // readOnly
  @Attr() createdAt!: string | null;

  // readOnly
  @Attr() modifiedAt!: string | null;

  // --- Relationships
  // -----------------

  // nullable
  @HasOne() createdBy!: User | null;

  // nullable
  @HasOne() modifiedBy!: User | null;

  // --- Paths
  // ---------

  /**
   * /backend/api/v1/sectors/
   *
   * Method: get
   * Params:
   *   - include: string
   *   - fields: object
   *   - sort: string
   *   - page[number]: integer
   *   - page[size]: integer
   *   - sort: string
   *   - filter[search]: string
   *
   */

  /**
   * /backend/api/v1/sectors/{id}/
   *
   * Method: get
   * Params:
   *   - id: string (required)
   *   - include: string
   *   - fields: object
   *   - sort: string
   *   - sort: string
   *   - filter[search]: string
   *
   */

  // --- Custom
  // ----------

  constructor(attrs?: HashAny) {
    super(attrs);

    this.locale = new LocaleItem(this, {
      keys: ['name'],
    }).asHash();
    // CHECK: Is locale creating a strong reference to this? Do we need to free it?
  }

  locale: Hash<string | undefined>;
}
